// Creator:yazawa Last Update:2023/4/17

const ENDPOINT_LIST = {
  'local': {
    'order': null,
    'login': null,
    'mypage': 'https://c5kn86lp3e.execute-api.ap-northeast-1.amazonaws.com/local/',
    'faq': 'https://kmgllfcsl1.execute-api.ap-northeast-1.amazonaws.com/local/',
    'idMailFromCognito': 'https://c5kn86lp3e.execute-api.ap-northeast-1.amazonaws.com/local/'
  },
  'local2': {
    'order': null,
    'login': null,
    'mypage': 'https://z9w7cte1x1.execute-api.ap-northeast-1.amazonaws.com/local2/',
    'faq': 'https://wjkvw76u3d.execute-api.ap-northeast-1.amazonaws.com/local2/',
    'idMailFromCognito': 'https://z9w7cte1x1.execute-api.ap-northeast-1.amazonaws.com/local2/'
  },
  'development': {
    'order': null,
    'login': null,
    'mypage': 'https://4ihp9ivhel.execute-api.ap-northeast-1.amazonaws.com/dev/',
    'faq': 'https://tgvep8h4qg.execute-api.ap-northeast-1.amazonaws.com/dev/',
    'idMailFromCognito': 'https://4ihp9ivhel.execute-api.ap-northeast-1.amazonaws.com/dev/'
  },
  'staging': {
    'order': null,
    'login': null,
    'mypage': 'https://64niso2ond.execute-api.ap-northeast-1.amazonaws.com/stg/',
    'faq': 'https://bwj78881hg.execute-api.ap-northeast-1.amazonaws.com/stg/',
    'idMailFromCognito': 'https://64niso2ond.execute-api.ap-northeast-1.amazonaws.com/stg/'
  },
  'staging2': {
    'order': null,
    'login': null,
    'mypage': 'https://z2di08ig8f.execute-api.ap-northeast-1.amazonaws.com/stg2/',
    'faq': 'https://q9w0m7x9s4.execute-api.ap-northeast-1.amazonaws.com/stg2/',
    'idMailFromCognito': 'https://z2di08ig8f.execute-api.ap-northeast-1.amazonaws.com/stg2/'
  },
  'staging3': {
    'order': null,
    'login': null,
    'mypage': 'https://y37to5nmql.execute-api.ap-northeast-1.amazonaws.com/stg3/',
    'faq': 'https://yf7k8zuor4.execute-api.ap-northeast-1.amazonaws.com/stg3/',
    'idMailFromCognito': 'https://y37to5nmql.execute-api.ap-northeast-1.amazonaws.com/stg3/'
  },
  'production': {
    'order': null,
    'login': null,
    'mypage': 'https://jkn7zk2cah.execute-api.ap-northeast-1.amazonaws.com/prod/',
    'faq': 'https://wcy9nuto9a.execute-api.ap-northeast-1.amazonaws.com/prod/',
    'idMailFromCognito': 'https://jkn7zk2cah.execute-api.ap-northeast-1.amazonaws.com/prod/'
  },
};

const env = process.env['NODE_ENV'] || 'local';

const state = {
  endPointOrder: ENDPOINT_LIST[env].order,
  endPointLogin: ENDPOINT_LIST[env].login,
  endPointMypage: ENDPOINT_LIST[env].mypage,
  endPointFaq: ENDPOINT_LIST[env].faq,
  endPointIdMailFromCognito: ENDPOINT_LIST[env].idMailFromCognito,
}

const getters = {
  getEndPointOrder: state => {
    return state.endPointOrder;
  },
  getEndPointLogin: state => {
    return state.endPointLogin;
  },
  getEndPointMypage: state => {
    return state.endPointMypage;
  },
  getEndPointFaq: state => {
    return state.endPointFaq;
  },
  getEndPointIdMailFromCognito: state => {
    return state.endPointIdMailFromCognito;
  },
}

export default {
    state,
    getters,
  }